import base from '../dr-base'
import addEds from './components/add-eds.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-eds',
  name: 'EDS(outdated)',
  group: 'EDS widgets',
  icon: 'file-alt',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-eds.disabled',
      type: 'string',
      default: ''
    },
    FileUrl: {
      type: 'string',
      name: 'vuetifyWidgets.dr-eds.fileUrl'
    },
    FileName: {
      type: 'string',
      name: 'vuetifyWidgets.dr-eds.fileName'
    },
    FileSignature: {
      type: 'string',
      name: 'vuetifyWidgets.dr-eds.fileSignature'
    },
    SaveKeyInSession: {
      name: 'vuetifyWidgets.dr-eds.saveKeyInSession',
      type: 'boolean',
      default: false
    },
    Caption: {
      name: 'vuetifyWidgets.dr-eds.caption',
      type: 'string',
      default: 'Sign',
      component: 'dr-value-editor'
    },
    Tooltip: {
      name: 'vuetifyWidgets.dr-eds.tooltip',
      type: 'string',
      default: 'Sign'
    },
    Color: {
      name: 'vuetifyWidgets.dr-eds.color',
      type: 'string',
      default: 'accent',
      component: 'dr-color-picker'
    },
    IconMode: {
      name: 'vuetifyWidgets.dr-eds.iconMode',
      type: 'boolean',
      enum: [ {
        value: true,
        text: 'vuetifyWidgets.dr-eds.iconMode'
      } ,{
        value: false,
        text: 'vuetifyWidgets.dr-eds.iconMode'
      }]
    },
    IconName: {
      name: 'vuetifyWidgets.dr-eds.iconName',
      type: 'string',
      default: '',
      component: 'dr-icon-picker'
    },
    OnClickAction: {
      name: 'vuetifyWidgets.dr-button.onClickAction',
      type: 'object',
      component: 'dr-prop-action',
      properties: { 
        ...drBaseActions.properties.OnClickAction.properties
      }
    },
    BeforeSigningAction: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-eds.actionBeforeSigning'
    },
    ButtonType: {
      name: 'vuetifyWidgets.dr-eds.buttonType',
      type: 'string',
      enum: [{
        value: 'simple',
        text: 'vuetifyWidgets.dr-eds.simple'
      } ,{
        value: 'toogle',
        text: 'vuetifyWidgets.dr-eds.toogle'
      }]
    },
    isRounded: {
      name: 'Rounded',
      type: 'boolean',
      default: false
    },
    isOutlined: {
      name: 'Outlined',
      type: 'boolean',
      default: false
    },
    isPlain: {
      name: 'Plain',
      type: 'boolean',
      default: false
    },
    isRaised: {
      name: 'Raised',
      type: 'boolean',
      default: false
    },
    isText: {
      name: 'Text',
      type: 'boolean',
      default: false
    }
  }
}

export default {
  schema,
  component: addEds,
  propEditors: [
    {
      name: 'dr-color-picker'
    },
    {
      name: 'dr-prop-action'
    }
  ]
}
